import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metamap_button = _resolveComponent("metamap-button")!

  return (_openBlock(), _createBlock(_component_metamap_button, {
    ref: "button",
    clientid: _ctx.clientId,
    "flow-id": _ctx.flowId,
    metadata: `{ "user_id": "${_ctx.userId}" }`,
    color: "#ffffff"
  }, null, 8, ["clientid", "flow-id", "metadata"]))
}